/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerStartWithPlayer = {
    properties: {
        player_id: {
            type: 'number',
            isRequired: true,
        },
        position: {
            type: 'PlayerPositionEnum',
            isRequired: true,
        },
        player: {
            type: 'any-of',
            contains: [{
                type: 'PlayerMedium',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
